import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import {
  type,
} from 'ramda';

export default class Toggle extends Component {

  constructor(props) {
    super(props);
    this.getFieldProp = this.getFieldProp.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.convertBoolean = this.convertBoolean.bind(this);
  }

  getFieldProp(prop) {
    let propItem = null;
    if (prop && this.props.field && this.props.field[prop] !== undefined) {
      propItem = prop === "value" ? this.convertBoolean(this.props.field[prop]) : this.props.field[prop];
    }

    return propItem;
  }

  convertBoolean(value) {
    if (type(value) === "Boolean") {
      return value;
    } else {
      let tmpValue = parseInt(value);
      value = tmpValue === 1;
    }

    return value;
  }

  changeValue() {
    this.props.field.value = !(this.convertBoolean(this.props.field.value));
    if (this.props.relatedTo && this.props.relatedTo.length > 0) {
      this.props.onChange(
        [
          this.props.relatedTo,
          this.props.field.name,
        ],
        this.props.field
      );
    } else {
      this.props.onChange(this.props.field.name, this.props.field);
    }
  }

  render() {
    const { className, customize = {}, labelPosition, disabled } = this.props;
    const labelOn = this.getFieldProp('labelOn');
    const labelOff = this.getFieldProp('labelOff');
    const containerClass = `form-group ${className}`;
    const labelPositionLeft = labelPosition === "left";
    return (
      <div className={`toggle-wrapper ${containerClass}`}>
        {labelPositionLeft &&
        <span className='toggle-label' style={customize}>{this.getFieldProp('label')}</span>
        }
        <label className='switch'>
          <input type="checkbox"
                 disabled={disabled}
                 checked={!!this.getFieldProp('value')}
                 onChange={(e) => { this.changeValue(); }}
          />
          <span className="slider round">
            {
              (labelOn || labelOff) && (<span>
                <span className="on">{labelOn}</span>
                <span className="off">{labelOff}</span>
              </span>)
            }
          </span>
        </label>
        {!labelPositionLeft &&
        <span className='toggle-label'>{this.getFieldProp('label')}</span>
        }
      </div>
    );
  }
}

Toggle.propTypes = {
  customize: PropTypes.object,
  labelPosition: PropTypes.string,
  field: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/Toggle/index.js